import React, { useContext } from 'react'
import GreyBoxForReports from './GreyBoxForReports'
import {  formatDateToMMDDYYYY } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { ApiGetCall } from '../../JS/Connector';
import { log } from '../../JS/Logger';
import useConfig from '../../Hooks/useConfig';

export default function AllHelpdeskTickets({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    const {organization} = useConfig();
    async function GetAllHelpdeskData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);
        await ApiGetCall(`/reports/helpdesk-tickets-all?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&flag=${downloadall}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length > 0) {
                    DownloadCsv(responseRs);
                } else {
                    DownloadCsv([]);
                    setalerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
                    setTimeout(() => {
                        setalerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                setLoading(false);
            }
        });
    }
    const DownloadCsv = (CsvData) => {
        const csvContent = [];
        const PurchaseMap = [];
        CsvData?.forEach((item) => {
            const rowData = {
                [`${organization} Name`]: item.school_name || '-',
                'Technology Tickets': item.total_tech_ticket || '-',
                'Maintenance Tickets': item.total_main_ticket || '-',
                'Other Tickets': item.total_other_ticket || '-',
                'Total Tickets': item.total || '-',
            };
            PurchaseMap.push(rowData);
        });
        if (PurchaseMap.length > 0) {
            const headers = [`${organization} Name`, 'Technology Tickets', 'Maintenance Tickets', 'Other Tickets', 'Total Tickets'];
            csvContent.push(headers);
            PurchaseMap.forEach((rowData) => {
                const values = Object.values(rowData).map(value => {
                    if (typeof value == 'string' && value.includes(',')) {
                        return `"${value}"`;
                    }
                    return value;
                });
                csvContent.push(values);
            });
            csvContent.push([]);
            const csvString = csvContent.map((row) => row.join(',')).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `HelpdeskBy${organization}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            log.error('No data available for download.');
        }
    };
    return (
        <GreyBoxForReports icon="faRobot" name={`All ${organization}s Name Help Desk Report Download`} onclickfunc={GetAllHelpdeskData} />
    )
}
